module.exports = __webpack_public_path__ + "static/media/delete.796f32b1.svg";